import React from 'react'

interface Props {
  title: string
  selected: boolean
  onClick: () => void
  iconName: string
}
const Item = ({title, selected, onClick, iconName}: Props) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      role="option"
      aria-selected={selected}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={`list-item ${selected ? 'selected' : ''}`}
    >
      <i
        className={`fa-regular icon ${iconName}`}
        aria-hidden="true"
        style={{fontSize: iconName === 'fa-user' ? '18px' : '17px'}}
      />
      <div className="list-title">{title}</div>
    </div>
  )
}

export default Item
